
export const timeoutToLaunchAiTutorial = 5000;

export const aiTutorialSteps = [
  {
    title: "look.ai.intro.sidebar.title",
    text: "look.ai.intro.sidebar.text",
    buttonText: "look.ai.intro.sidebar.button",
    styles: {
      transform: "translate(-7px, 87px)",
      width: "44px",
      height: "172px",
    },
    boxStyles: {
      transform: "translate(64px, -12px)",
    }
  },
  {
    title: "look.ai.intro.upload.title",
    text: "look.ai.intro.upload.text",
    buttonText: "buttons.next",
    styles: {
      transform: "translate(80px, 104px)",
      width: "272px",
      height: "148px"
    },
    boxStyles: {
      transform: "translate(300px, -20px)",
    }
  },
  {
    title: "look.ai.intro.groups.title",
    text: "look.ai.intro.groups.text",
    buttonText: "buttons.next",
    styles: {
      transform: "translate(80px, 312px)",
      width: "272px",
      height: "152px"
    },
    boxStyles: {
      transform: "translate(300px, -70px)",
    }
  },
  {
    title: "look.ai.intro.generate.title",
    text: "look.ai.intro.generate.text",
    buttonText: "look.ai.intro.generate.button",
    styles: {
      transform: "translate(80px, 0)",
      width: "272px",
      height: "92px"
    },
    boxStyles: {
      transform: "translate(300px, -121px)",
    }
  }
];

export const getAiStepStyles = (aiTutorialStepIndex, isMobile, showTutorial) => {
  let greenBorderStyles = {}, boxStyles = {};

  const step = aiTutorialSteps[aiTutorialStepIndex];
  if (!step) return { greenBorderStyles, boxStyles };

  // clone to avoid mutating (possibly frozen) config
  greenBorderStyles = { ...step.styles };
  boxStyles = { ...step.boxStyles };

  if (aiTutorialStepIndex === 0) {
    if (isMobile) {
      greenBorderStyles.width = window.innerHeight < 320 ? "40px" : "48px";
      greenBorderStyles.height = window.innerHeight < 320 ? "40px" : "48px";
      greenBorderStyles.transform = window.innerHeight < 320 ? "translate(12px, 178px)" : "translate(8px, 178px)";
      boxStyles.transform = window.innerHeight < 320 ? "translate(68px, -50%)" : "translate(68px, -70px)";
      const sidebarButton = document.getElementById("aiMobileButton");
      if (sidebarButton) {
        const rect = sidebarButton.getBoundingClientRect();
        greenBorderStyles.transform = window.innerHeight < 320 ? `translate(12px, ${rect.top}px)` : `translate(8px, ${rect.top}px)`;
      }
    } else {
      greenBorderStyles.width = "44px";
      greenBorderStyles.height = "172px";
      const sidebarDiv = document.querySelector(".look-ai__sidebar");
      if (sidebarDiv) {
        const rect = sidebarDiv.getBoundingClientRect();
        greenBorderStyles.transform = `translate(-7px, ${rect.top - 5}px)`;
      }
    }
  } else if (aiTutorialStepIndex === 1) {
    const dropzoneDiv = document.querySelector(".look-ai__sidebar-content--dropzone");
    if (dropzoneDiv) {
      const rect = dropzoneDiv.getBoundingClientRect();
      greenBorderStyles.transform = `translate(80px, ${rect.top - 8}px)`;
    }
    const scrollDiv = document.querySelector(".look-ai__content");
    if (scrollDiv && (scrollDiv.scrollHeight > scrollDiv.clientHeight)) { // reduce the width a little, as we have a 6px scrollbar
      greenBorderStyles.width = (+greenBorderStyles.width.split("px")[0] - 6) + "px";
    }
  } else if (aiTutorialStepIndex === 2) {
    const groupsDiv = document.getElementById("look-ai__panel-feature-groups");
    if (groupsDiv && showTutorial) {
      groupsDiv.scrollIntoView({ block: "start" });
      const rect = groupsDiv.getBoundingClientRect();
      greenBorderStyles.height = `${groupsDiv.clientHeight + 12}px`;
      greenBorderStyles.transform = `translate(80px, ${rect.top - 8}px)`;
      if (isMobile) {
        // boxStyles.transform = "translate(300px, -25%)"; // we can't do that since the height is always different
        // scale proportionally:
        const yTranslate = Math.max(-25, Math.min(0, (25 * ((groupsDiv.clientHeight + 12) - 325)) / 171)); // in percent
        boxStyles.transform = `translate(300px, ${yTranslate}%)`;
      }
    }
  } else if (aiTutorialStepIndex === 3) {
    greenBorderStyles.transform = `translate(80px, ${window.innerHeight - 99}px)`;
  }
  return {greenBorderStyles, boxStyles};
}

// export const getBoundingClientRectObject = element => {
//   if (!element) {
//     return {}
//   }
//   const {top, right, bottom, left, width, height, x, y} = element.getBoundingClientRect()
//   return {top, right, bottom, left, width, height, x, y}
// }
